/** @file World origin of a posed bone. */
import { POSE_LAYOUT } from '@pose2d/core/contracts/pose';
import type { Pose } from '@pose2d/core/types';
import type { Vec2 } from '@pose2d/math/types';

/** [tx, ty] of `pose.world` for data bone `i`. */
export function boneOrigin(pose: Pose, i: number): Vec2 {
  const base = i * POSE_LAYOUT.WORLD_STRIDE;
  return [pose.world[base + 4] ?? 0, pose.world[base + 5] ?? 0];
}
